import React, { useState } from 'react';
import {
	CardBody,
	CardHeader,
	CardTitle,
	Col,
	Row,
	Table,
	Button,
	Card,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownItem,
	DropdownMenu
} from 'reactstrap';
import { Edit, MoreVertical, Trash } from 'react-feather';
import { useFetchInstructors } from '../data/swrs/instructor';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../data/atoms/utilsAtoms';
import { useNavigate } from 'react-router-dom';
import AddInstructorModal from './AddInstructorModal';

const Instructors = () => {
	const [modal, setModal] = useState(false);
	const [selectedInstructor, setSelectedInstructor] = useState(null);
	const userData = useAtomValue(userInfoAtom);
	const { instructors, isError } = useFetchInstructors(userData?.token);
	const [isEdit, setIsEdit] = useState(false);
	const navigate = useNavigate();

	const onEdit = (e, instructor) => {
		e.preventDefault();
		setSelectedInstructor(instructor);
		setIsEdit(true);
		setModal(true);
	};

	return (
		<Card className="admin_instrcutor">
			<CardHeader>
				<CardTitle tag="h4">Instructors</CardTitle>
			</CardHeader>
			<CardBody>
				<Row>
					<Col md="12" className="d-flex justify-content-end">
						<div className="w-30">
							<Button
								color="primary"
								onClick={() => {
									setSelectedInstructor(null);
									setModal(true);
								}}
								className="mt-2"
							>
								Add Instructor
							</Button>
						</div>
					</Col>
				</Row>

				<Row className="mt-2">
					<Col md="12">
						<Table>
							<thead>
								<tr>
									<th>Name</th>
									<th>Edit</th>
								</tr>
							</thead>
							<tbody>
								{instructors && Array.isArray(instructors) && instructors?.length > 0 ? (
									instructors?.map((el, i) => (
										<tr key={i}>
											<td>{el?.name}</td>
											<td>
												<div onClick={e => onEdit(e, el)} style={{ cursor: 'pointer' }}>
													<Edit className="me-50" size={15} />
												</div>
											</td>
										</tr>
									))
								) : (
									<tr>
										<td className="text-center" colSpan={2}>
											No Data Found
										</td>
									</tr>
								)}
							</tbody>
						</Table>
					</Col>
				</Row>
			</CardBody>

			{modal && (
				<AddInstructorModal
					isOpen={modal}
					toggle={() => setModal(!modal)}
					instructor={selectedInstructor}
					isEdit={isEdit}
				/>
			)}
		</Card>
	);
};

export default Instructors;
